import { createReducer, on } from '@ngrx/store';
import { FormGroupState } from '@shared/models/common';
import { RechercheForm } from '@features/demande-remboursement/choix-dossier/models/recherche-form';
import { MesDossiersSearchFormActions } from '@features/demande-remboursement/choix-dossier/store/search/search.actions';

export const featureKey = 'mesDossiersRechercheForm';

export interface RechercheFormState extends FormGroupState<RechercheForm> {
  resetDone: boolean;
  isLoading: boolean;
}

export const initialState: RechercheFormState = {
  value: new RechercheForm(),
  checkingForm: false,
  isValid: false,
  errorMessage: null,
  errors: [],
  resetDone: true,
  isLoading: false
};

export const mesDossiersRechercheReducers = createReducer(
  initialState,
  on(MesDossiersSearchFormActions.updateSearchForm, (state, { form }) => ({
    ...state,
    value: form,
  })),

  on(MesDossiersSearchFormActions.resetSearchForm, (state) => ({
    ...state,
    querySiret: '',
    value: new RechercheForm(),
  })),

  on(MesDossiersSearchFormActions.resetDone, (state, { resetDone }) => ({
    ...state,
    resetDone,
  })),
  on(MesDossiersSearchFormActions.updateIsDossiersEligibles, (state, { isDossierEligible }) => ({
    ...state,
    value: {
      ...state.value,
      eligible: isDossierEligible,
      isUpdateRequired: false,
      page: 0
    },
  })),
  on(MesDossiersSearchFormActions.updateIsLoading, (state, { isLoading }) => ({
    ...state,
    isLoading: isLoading
  })),
  on(MesDossiersSearchFormActions.resetForm, () => initialState)
);
